<template>
	<Transition name="site-alert__anim">
		<div v-if="can_display" class="site-alert" :style="computed_bar_style">
			<div class="site-alert__message"><slot name="message"></slot></div>
			<div class="site-alert__button" :style="computed_button_style" @click="dismiss"><slot name="button"></slot></div>
			<div class="site-alert__dismiss" @click="dismiss">
				<svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
				</svg>
			</div>
		</div>
	</Transition>
</template>

<script>
import ls from 'localstorage-slim';

export default {
	props: {
		payload: {
			type: String
		}
	},
	data() {
		return {
			alert: false,
			dismissed: false
		}
	},
	mounted() {
		this.dismissed = (ls.get('esc_sad', { decrypt: true }) === true);
		this.alert = JSON.parse(this.payload);
	},
	methods: {
		dismiss() {
			this.dismissed = true;
			ls.set('esc_sad', true, { ttl: (60*60*24*7), encrypt: true }); // Dismiss for 1 week.
		}
	},
	computed: {
		computed_bar_style() {
			let styles = [];
			styles.push('background-color:#'+this.alert['bar-background-colour']+';');
			styles.push('color:#'+this.alert['bar-text-colour']+';');
			return styles.join("");
		},
		computed_button_style() {
			let styles = [];
			styles.push('background-color:#'+this.alert['button-colour']+';');
			styles.push('color:#'+this.alert['button-text-colour']+';');
			return styles.join("");
		},
		can_display() {
			return (this.alert && !this.dismissed);
		}
	}
}
</script>
